/** Value by which total product price is multiplied when order is cancelled */
export const CANCELLATION_DISCOUNT_MULTIPLIER = 0.75